
export default function ArchitecturalProjectsSection() {
  return (
    <section className="py-16 bg-[#F2F2F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/cc877d396237a06639d0b0645195c70c.jpeg"
                alt="Projetos Arquitetônicos de Alto Padrão"
                className="w-full h-80 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#5C1A24]/20 to-transparent"></div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-[#5C1A24] rounded-full flex items-center justify-center mr-4">
                <i className="ri-building-line text-white text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24]" style={{ fontFamily: '"Playfair Display", serif' }}>
                Projetos Arquitetônicos de Alto Padrão
              </h2>
            </div>
            
            <div className="text-[#3F3F3F] leading-relaxed space-y-4">
              <p>
                Projetamos casas e espaços comerciais únicos, refletindo o estilo e a personalidade de cada cliente.
              </p>
              <p>
                Combinamos design autoral e soluções técnicas inteligentes, criando ambientes elegantes, funcionais e duradouros.
              </p>
              <p className="font-medium text-[#5C1A24]">
                Ideal para quem busca projetos residenciais e comerciais de luxo em São Paulo.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                'Design personalizado',
                'Materiais premium',
                'Soluções sustentáveis',
                'Acompanhamento completo'
              ].map((feature, index) => (
                <div key={index} className="flex items-center">
                  <i className="ri-check-line text-[#5C1A24] mr-2"></i>
                  <span className="text-sm text-[#3F3F3F]">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
